module.exports = __webpack_public_path__ + "static/media/BT.4dba09c1.png";